import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SelectedTab {
  selectedTab: any[];
  firstCategoryId: number | null;
}

const initialState: SelectedTab = {
  selectedTab: [],
  firstCategoryId: null,
};

const selectedTabSlice = createSlice({
  name: 'selectedTab',
  initialState,
  reducers: {
    setSelectedTab: (state, action: PayloadAction<any[]>) => {
      state.selectedTab = action.payload;
    },
    setFirstCategoryId: (state, action: PayloadAction<number>) => {
      state.firstCategoryId = action.payload;
    },
  },
});

export const { setSelectedTab, setFirstCategoryId } = selectedTabSlice.actions;
export default selectedTabSlice.reducer;
